import dateFormats from "../app/data/common/dateFormats";
import moment from "moment";

export {};

declare global {
  interface Date {
    toUiFormat: () => string;
    toApiFormat: () => string;
  }
}

export function initDateExtenstions() {
  // eslint-disable-next-line no-extend-native
  Date.prototype.toUiFormat = function() {
    return moment(this).format(dateFormats.uiDate);
  };
  // eslint-disable-next-line no-extend-native
  Date.prototype.toApiFormat = function () {
    return moment(this).format(dateFormats.apiDate);
  };
}
